import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://api.leaderbored.gg/api",
  // baseURL: "https://leaderbored-api.taktylstudios.com/api",
  // headers: {
  //   'Cache-Control': 'public, max-age=31536000',
  //   'Accept-Encoding': 'gzip, deflate, br'
  // }
  // maxContentLength: 100 * 1024 * 1024,
  // maxBodyLength: 100 * 1024 * 1024,
});

export default axiosInstance;
